module.exports = __webpack_public_path__ + "static/media/subaru.5b2d996a.jpg";